import { DebtLegTerms } from 'models/DebtLegTerms';

export const empty_debt_leg_terms: DebtLegTerms = {
  currency_id: 1,
  notional: null,
  coupon: null,
  price: null,
  par: null, //no send -  ((action.value / action.notional) * 100).toFixed(2),
  debt_yield: 0,
  fees: 0,
  effective_date: null,
  maturity_date: null,
  toggle_roll_fields_flag: false,
  first_payment_date: null,
  next_to_last_payment_date: null,
  eom_roll: false,
  pay_frequency: null,
  //pay_start_end: null,
  business_day_convention: null,
  payment_calendars: null,
  day_count_id: null,
  discounting_index_id: null,
  cds_curve_id: null,
  cds_spread: null,
  collateral_currency: null,
  reset_frequency: null,
  // Notional Exchange Fields
  toggle_notional_exchange_fields_flag: false,
  initial_notional_exchange: false,
  intermediary_notional_exchange: false,
  final_notional_exchange: false,

  //float leg
  interest_rate_index_id: null,
  spread: 0,
  debt_floor_enabled: false, //need it?
  floor: null,
  reset_calendars: null,
};
